













import { Vue, Component, Prop, Watch } from "vue-property-decorator";

export type LargeRadioItem = {
  id: string;
  text: string;
};

@Component
export default class VLargeRadio extends Vue {
  @Prop({ required: true }) readonly items!: LargeRadioItem[];
  @Prop({ required: true }) readonly value!: LargeRadioItem | null;

  selected: LargeRadioItem | null = Object.assign({}, this.value);

  @Watch("value")
  onValueChanged(value: LargeRadioItem | null) {
    this.selected = value;
  }

  isSelected(value: LargeRadioItem) {
    return this.selected === value;
  }

  onItemClick(value: LargeRadioItem) {
    this.selected = value;
    this.$emit("input", value);
  }
}
